import { FormControl, FormLabel, Stack, Text } from '@chakra-ui/react'
import type { AcquisitionNumber, DetailedUser, EditUser } from 'BrokerTsLib/src/dtos'
import { useGetAvailableInsurers } from 'BrokerTsLib/src/hooks/useOrganizationUnit'
import { useFieldArray, useFormContext } from 'BrokerTsLib/src/rhf'
import type { Ref } from 'react'
import { forwardRef, useEffect } from 'react'

import { InputGroup } from '@/components'
import type { FormSectionProps } from '@/containers/forms/FormSection'
import { FormSection } from '@/containers/forms/FormSection'

export const UserPersonalNumbersFormSection = forwardRef(
  function UserPersonalNumbersFormSection({ user, ...rest }: { user: DetailedUser } & FormSectionProps, ref: Ref<HTMLDivElement>) {
    const { register, control, watch, setValue } = useFormContext<EditUser>()

    const { fields } = useFieldArray({
      name: 'personalNumbers',
      control,
    })

    const personalNumbers = watch('personalNumbers')
    const { data: insurersData } = useGetAvailableInsurers(user.organizationUnitId)
    useEffect(() => {
      if (insurersData?.data) {
        const personalNumbersAvailableInsurers: AcquisitionNumber[] = insurersData?.data.map(i => ({
          insurerId: i.insurerId,
          insurerName: i.insurer,
          acquisitionNumber: personalNumbers?.find(p => p.insurerId === i.insurerId)?.acquisitionNumber ?? ''
        }))
        // We want to also show already assigned personal numbers for insurers that are not available
        const personalNumbersAll = personalNumbersAvailableInsurers.concat(
          personalNumbers?.filter(p => !personalNumbersAvailableInsurers.some(p2 => p2.insurerId === p.insurerId)) ?? []
        )
        setValue('personalNumbers', personalNumbersAll.slice().sort((a, b) => a.insurerName.localeCompare(b.insurerName)))
      }
    }, [insurersData])

    return <FormSection ref={ref} sectionTitle='Osobní čísla' {...rest}>
      <Stack gap={6}>
        {fields.length === 0 && <Text>Nejsou dostupné žádné pojišťovny pro nastavení osobních čísel.</Text>}
        {fields.map((number, index) =>
          <FormControl key={number.insurerId}>
            <FormLabel fontWeight={'semibold'}>{number.insurerName}</FormLabel>

            <InputGroup flex={1} id={number.insurerName} {...register(`personalNumbers.${index}.acquisitionNumber`, { required: false })} />
          </FormControl>
        )}
      </Stack>
    </FormSection>
  }
)